module.exports = __webpack_public_path__ + "img/logo_ytss_rectangle.0460b14b.png";